import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface ITestFilterStrings extends LocalizedStringsMethods {
    lsAthleteTxt: string;
    lsStartEndDateTxt: string;
    lsTestTypeTxt: string;
    lsBaselineTxt: string;
    lsConussionTxt: string;
    lsDateFormat: string;
}

let strings: ITestFilterStrings;
export default strings = new LocalizedStrings({
    en: {
        lsAthleteTxt: 'Athlete Name',
        lsStartEndDateTxt: 'Start and End Date',
        lsTestTypeTxt: 'Score Type',
        lsBaselineTxt: 'Baseline',
        lsConussionTxt: 'Dr Dx Conussion',
        lsDateFormat: 'MM/DD/YYYY'
    },
    es: {
        lsAthleteTxt: 'Nombre del atleta',
        lsStartEndDateTxt: 'Fecha de inicio y finalización',
        lsTestTypeTxt: 'Tipo de puntuación',
        lsBaselineTxt: 'Base',
        lsConussionTxt: 'Dr Dx Conussion',
        lsDateFormat: 'DD/MM/YYYY'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/test/string.test.filter.tsx